module.exports = __webpack_public_path__ + "2a4bdafe8294d5be9e4f9f03e5d1a31a.glb";